export default __webpack_public_path__ + "static/media/goagent_team.05f6f1f6.jpg";